import React, { useState, useEffect } from "react";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { getAllZoneWiseReport } from "../../../Apis/scvReports/reportedSCVApi";
import { useLocation } from "react-router-dom";
import { GetZone } from "../../../Apis/organizationApi";
const ViewInnerGVPClearenceReport = () => {
  const headers = [
    "vehicleNumber",
    "zone",
    "circle",
    "ward",
    "driverName",
    "beforeLatitude",
    "beforeLongitude",
    "afterLatitude",
    "afterLongitude",
    "vehicleUuid",
    "beforeDateTime",
    "afterDateTime",
    "beforeImage",
    "afterImage",
  ];

  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const data = location.state;

  const [zoneName, setZoneName] = useState("");
  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        // Populate the zoneNamesDictionary with zoneId as keys and zoneName as values
        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        // Find the zone name corresponding to the zoneId from localStorage
        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];

        // Use zoneName as needed
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);

  const modifiedData = data.map((item) => ({
    ...item,
    zone: item.zoneName, // Save value of zoneName to zone column
    circle: item.circleName, // Save value of zoneName to zone column
    ward: item.wardName,
    beforeImage: item.beforeImageUrl,
    afterImage: item.afterImageUrl,
  }));
  //       setZonesData(modifiedData);
  //       // Handle the response data as needed
  //     } catch (error) {
  //       console.error("Error fetching zone wise report:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   const handleSearch = () => {
  //     fetchData(); // Call fetchData when the search button is clicked
  //   };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header"></div>

            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>No. of GVPs Clearance Report</span>
                </div>

                <TableComponent isLoading={isLoading} DataFetchURL={modifiedData} headers={headers} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default ViewInnerGVPClearenceReport;
